function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//@ts-nocheck

/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import React from 'react';
import { StyleSheet, View } from 'react-native';
import { ModalResolver } from "./modalResolver.component";
import { ModalService } from "./modal.service";
export class ModalPanel extends React.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "state", {
      components: new Map()
    });

    _defineProperty(this, "hide", identifier => {
      const components = this.state.components;
      components.delete(identifier);
      this.setState({
        components
      });
      return '';
    });

    _defineProperty(this, "generateUniqueComponentKey", () => {
      return Math.random().toString(36).substring(2);
    });

    _defineProperty(this, "areThereAnyComponents", () => {
      return this.state.components && this.state.components.size !== 0;
    });

    _defineProperty(this, "renderModal", (config, index) => {
      return /*#__PURE__*/React.createElement(ModalResolver, {
        key: index,
        visible: true,
        backdropStyle: config.backdropStyle,
        onBackdropPress: config.onBackdropPress
      }, config.element);
    });

    _defineProperty(this, "renderModals", () => {
      return Array.from(this.state.components.values()).map(this.renderModal);
    });
  }

  componentDidMount() {
    ModalService.mount(this);
  }

  componentWillUnmount() {
    ModalService.unmount();
  }

  show(element, config) {
    const key = this.generateUniqueComponentKey();
    const components = this.state.components.set(key, _objectSpread(_objectSpread({}, config), {}, {
      element
    }));
    this.setState({
      components
    });
    return key;
  }

  update(identifier, children) {
    const panelChild = this.state.components.get(identifier);

    if (!panelChild) {
      return;
    }

    const childElement = panelChild.element;
    panelChild.element = /*#__PURE__*/React.cloneElement(childElement, childElement.props, children);
    const components = this.state.components;
    components.set(identifier, panelChild);
    this.forceUpdate();
  }

  render() {
    return /*#__PURE__*/React.createElement(View, {
      style: styles.container
    }, this.props.children, this.areThereAnyComponents() && this.renderModals());
  }

}
const styles = StyleSheet.create({
  container: {
    flex: 1
  }
});